/* eslint-disable no-undef */
import * as firebase from 'firebase/app';
import 'firebase/messaging';

import { notify } from '@lib/notifier';
import { employeeDeviceToken } from '@features/common/api';
import { getNotifications } from './notifications-flow';
import { notificationMsg } from './notification-msg';

const config = {
  apiKey: 'AIzaSyBJJ0Zt9gA7g5xNFLeSHDdJXkEmCCMhq1s',
  authDomain: 'oca-internal.firebaseapp.com',
  databaseURL: 'https://oca-internal.firebaseio.com',
  projectId: 'oca-internal',
  storageBucket: 'oca-internal.appspot.com',
  messagingSenderId: '406642648730',
  appId: '1:406642648730:web:faf9bb6ff02f8b61',
};

export const firebaseConfigs = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(config);

    if ('serviceWorker' in navigator && firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();

      messaging.usePublicVapidKey(
        'BGysg5ge4CyzjWwUi2_reTzyYDb_40Ep3yc-zbY3x4ycWyJ9bLwz-mRDgPkvlOFU-zOZ_Bz2_StcQEnZHS0pWCM',
      );

      /*
        action: "created"
        author_first_name: "Nurpeyis"
        author_last_name: "Kalbekov"
        avatar: "https://devz.inobi.kg:7000/media/users/avatars/%D0%9D%D1%83%D1%80%D0%BF%D0%B5%D0%B9%D0%B8%D1%811.jpg"
        created_date: "2019-06-20 10:56:23.712016+00:00"
        domain: "task"
        domain_obj_id: "85"
        msg_body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
        msg_title: "Today is 13th of June"
        notification_id: "2378"
       */

      messaging
        .requestPermission()
        .then(() => messaging.getToken())
        .then(token => employeeDeviceToken(token))
        .catch(error => console.log('Error occured:', error));

      messaging.onMessage(({ data }) => {
        const { notificationTitle } = notificationMsg(
          data.msg_title,
          data.action,
          data.domain,
          data.domain_obj_id,
        );

        getNotifications().then(() => {
          notify.success(notificationTitle);
        });
      });
    } else {
      console.log('Push not supported.');
    }
  }
};
